import { isNaN } from 'lodash-es'
import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'

import { MANAGED_EVENT_TYPE } from 'constants/event_types'
import { useEventTypeEditorSidebar } from 'features/event_type_editor'

export const Edit = (props) => {
  const managedEventTypeId = parseInt(props.match.params.id, 10)
  const managedEventTypeUrl = props.match.url
  const managedEventTypeListPath = '/app/admin/managed_event_types'
  const { openSidebar: openEventTypeSidebar } = useEventTypeEditorSidebar()

  useEffect(() => {
    if (isNaN(managedEventTypeId)) return

    openEventTypeSidebar({
      id: managedEventTypeId,
      type: MANAGED_EVENT_TYPE,
      ownerType: 'Organization',
      ...(managedEventTypeUrl.endsWith('assign') ? { defaultOpenKey: 'assign' } : {})
    })
  }, [managedEventTypeId, managedEventTypeUrl, openEventTypeSidebar])

  return (
    <Redirect
      from={managedEventTypeUrl}
      to={managedEventTypeListPath}
    />
  )
}
